"use client"

import { useEffect, useState } from "react"

// The landing "Client" toggle is a client-side STATE on the home page (`/`),
// not a route — so the global chrome that normally shows on `/` (the Sign Up
// CTA, the mobile wordmark, the floating nav) can't hide via a pathname list
// the way it does on `/clients`. The landing broadcasts this event when it
// enters/leaves client mode; chrome components subscribe and hide while it's on
// (and it resets to false when the landing unmounts, so it never leaks to other
// routes).
export const LANDING_CLIENT_MODE_EVENT = "booth:landing-client-mode"

export function useLandingClientMode(): boolean {
  const [on, setOn] = useState(false)
  useEffect(() => {
    const handler = (e: Event) => setOn(Boolean((e as CustomEvent<boolean>).detail))
    window.addEventListener(LANDING_CLIENT_MODE_EVENT, handler as EventListener)
    return () => window.removeEventListener(LANDING_CLIENT_MODE_EVENT, handler as EventListener)
  }, [])
  return on
}
